module.exports = __webpack_public_path__ + "b9b7faa0.svg";